<template>
	<div>
		<notifications />
		<section class="heading">
			<h1 class="title">Recurring Invoices</h1>
			<router-link to="recurring-invoices/create" class="btn btn-primary btn-lg">Add new Invoice</router-link>
		</section>
		<ul class="nav nav-tabs">
			<li class="nav-item active" @click="statusActive('active')"><a class="nav-link" href="#first" data-toggle="tab" id="active">Active</a></li>
			<li class="nav-item" @click="statusActive('inactive')"><a class="nav-link" href="#second" data-toggle="tab" id="inactive">Inactive</a></li>
		</ul>
        <preloader v-if="isLoading"></preloader>
		<div class="table-responsive">
			<table class="table">
				<thead>
					<tr>
						<th>Invoice Information</th>
						<th width="15%">Grand Total</th>
						<th>Start Date</th>
						<th>End Date</th>
						<!-- <th>Last Sent Email</th> -->
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in invoices.data" :key="item.id">
						<td>
							<b>
								<router-link :to="relativeUrl(`/recurring-invoices/${item.id}/view`)">
								{{ item.frequency == 30? 'Monthly': (item.frequency == 365 ? 'Yearly': '') }} <br />{{ item.title }}
								</router-link>
							</b> <br/>
							<span class="label label-success" v-if="item.is_paid">PAID</span>
						</td>
						<td>{{ formatPrice(item.grandtotal) }}</td>
						<td>{{ displayDate(item.start_date) }}</td>
						<td>{{ isDate(item.end_date) }}</td>
						<!-- <td>
							<time-ago :datetime="`${item.last_sent_email_at}`" long v-if="isValidDate(item.last_sent_email_at)"></time-ago>
						</td>  -->
						<td>
							<action-button id="dropdownMenu1">
								<ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
									<!-- <li><router-link :to="relativeUrl(`/recurring-invoices/${item.id}/edit`)">Edit</router-link></li> -->
									<li><router-link :to="relativeUrl(`/recurring-invoices/create?duplicate_id=${item.id}`)">Duplicate</router-link></li>
									<li><router-link :to="relativeUrl(`/recurring-invoices/${item.id}/view`)">View</router-link></li>
									<!-- <li><router-link :to="relativeUrl(`/invoices?recurring_invoice_id=`+item.id)">View Invoice</router-link></li> -->
									<li><a :href="'/invoices?recurring_invoice_id='+item.id">View Invoice</a></li>
									<li><a v-if="status == 'active'" href="#" @click="remove(item.id)">Stop</a></li>
								</ul>
							</action-button>
						</td>
					</tr>
					<tr colspan="5" v-if="invoices.data.length <= 0">
						No data
					</tr>
				</tbody>
			</table>
		</div>
		<amy-pagination :pagination="invoices"></amy-pagination>
	</div>
</template>

<script>
import { getPage, relativeUrl, formatPrice, displayDate, isValidDate } from "../../helpers";
import AmyPagination from "../AmyPagination.vue";
import ActionButton from "../ActionButton.vue";
import TimeAgo from "vue2-timeago";
import { RecurringInvoice } from '../../repositories'
import Preloader from "../Preloader.vue";

export default {
	components: {
		AmyPagination, ActionButton, TimeAgo, Preloader
	},
	data() {
		return {
			invoices: {
				total: 0,
				per_page: 10,
				from: 1,
				to: 0,
				current_page: 1,
				data: [],
			},
			isLoading: false,
			isActive: true,
			// data: [],
			status: 'active'
		}
	},
	beforeMount() {
		this.getInvoices();
	},
	beforeRouteUpdate(to, from, next) {
		this.getInvoices(to);
		next();
	},
	methods: {
		async remove(id) {
			this.isLoading = true;

			try {
				const response = await axios.post(`/recurring-invoices/${id}/stop`);
				this.getInvoices();
				this.$notify({
					type: 'success',
					title: 'Recurring Invoice Stopped!',
					text: 'You\'ve stopped the recurring invoice!'
				})
			} catch {
				this.$notify({
					type: 'error',
					title: 'Oops!',
					text: 'Sorry, an error occured!'
				})
			}

			this.isLoading = false;
		},
		async getInvoices(route = this.$route) {
			this.isLoading = true;

			try {
				const response = await axios.get(`/recurring-invoices`, {
					params: {
						page: getPage(route),
						status: this.status
					}
				});
				// const response = await RecurringInvoice.getAsync();
				this.invoices = { ...response.data };
				// this.statusActive(true)
			} catch {
				this.$notify({
					type: 'error',
					title: 'Oops!',
					text: 'Sorry, an error occured!'
				})
			}

			this.isLoading = false;
		},
		statusActive(status) {
			this.status = status
			this.getInvoices()
			
		},
		// fills(start, end) {
		// 	return (new Date(start) > new Date() || new Date(end) < new Date() );
		// },
		isDate(date) {
			return (date && !isNaN(new Date(date)) ) ? displayDate(date) : '-';
		},
		relativeUrl, formatPrice, displayDate, isValidDate
	}
}
</script>
